export const options = {
  0: {
    "title": "Means of Transport",
    "question": "Which statement describes your transportation habits the best?",
    "list": [
      { label: "I walk or bike most of the time and only use public transport sometimes.", value: 1, weight: 0.1 },
      { label: "I mostly use public transport and sometimes walk or bike.", value: 2, weight: 1.5 },
      { label: "I usually drive but also use public transport or walk occasionally.", value: 3, weight: 3 },
      { label: "I mainly drive without using public transport or walking/biking much.", value: 4, weight: 4.6 },
    ]
  },
  1: {
    "title": "Private Flights",
    "list": [
      { label: "How many round-trip flights on private jets do you typically take in a year?", value: 1, weight: 4.5 },
    ]
  },
  2: {
    "title": "Commercial Flights",
    "list": [
      { label: "How many round-trip flights do you typically take on commercial airlines in a year?", value: 1, weight: 1 },
    ]
  },
  3: {
    "title": "Food",
    "question": "How often do you consume meat and animal products?",
    "list": [
      { label: "I eat only vegan food.", value: 1, weight: 1 },
      { label: "I mostly eat vegetarian food.", value: 2, weight: 2.5 },
      { label: "I eat meat every other day on average.", value: 3, weight: 3.3 },
      { label: "I eat meat at almost every meal.", value: 4, weight: 5 },
    ]
  },
  4: {
    "title": "Shopping",
    "question": "How often do you purchase new clothing, devices, or furniture? Choose the most accurate option:",
    "list": [
      { label: "Mostly second-hand.", value: 1, weight: 0 },
      { label: "Less than $300 USD per month.", value: 2, weight: 0.01 },
      { label: "Between $300 and $500 USD per month.", value: 3, weight: 0.03 },
      { label: "Between $500 and $1000 USD per month.", value: 4, weight: 0.1 },
      { label: "More than $1000 USD per month.", value: 5, weight: 1 },
    ]
  },
  5: {
    "title": "Leisure",
    "question": "How much do you typically spend on leisure and cultural activities, including restaurants and fitness? Choose the most accurate option:",
    "list": [
      { label: "Less than $300 USD per month.", value: 1, weight: 0.01 },
      { label: "Between $300 and $500 USD per month.", value: 2, weight: 0.03 },
      { label: "Between $500 and $1000 USD per month.", value: 3, weight: 0.1 },
      { label: "More than $1000 USD per month.", value: 4, weight: 1 },
    ]
  },
  6: {
    "title": "Living Space",
    "question": "Which statement describes your living space the best?",
    "list": [
      { label: "I live in a small space, such as a condo with several roommates.", value: 1, weight: 5 },
      { label: "I live in a large space, such as a detached house.", value: 2, weight: 8 },
      { label: "I live in a mansion.", value: 3, weight: 50 },
    ]
  },
  7: {
    "title": "Construction",
    "question": "Which statement describes your living situation the best?",
    "list": [
      { label: "I live in a renovated, energy-efficient house.", value: 1, weight: 0.5 },
      { label: "I live in an older house that has not been renovated for energy efficiency.", value: 2, weight: 0 },
    ]
  }
}